import { useTranslation } from 'react-i18next';

import RulerShape from '@/components/common/svg/shapes/RulerShape.tsx';
import BodyShape from '@/components/common/svg/shapes/BodyShape.tsx';
import BriefcaseShape from '@/components/common/svg/shapes/BriefcaseShape.tsx';
import { CandidateProfileApi } from '@/api/matchmaker/types.ts';
import { getBodyTypes } from '@/components/Popup/EditProfile/EditBodyTypePopup.tsx';
import { getEmploymentSectors } from '@/components/Popup/EditProfile/EditEmploymentPopup.tsx';
import { BodyType, EmploymentSector, ZodiacSign } from '@/enums/apiEnums.ts';
import {
  getZodiacSigns,
  zodiacIcons
} from '@/components/Popup/EditProfile/EditZodiacPopup.tsx';
import { InputContent } from '@/components/common/InputContent/InputContent.tsx';
import { tagStyle } from '@/components/UserProfile/styles.ts';

type PersonalInfoBlockProps = {
  profile_data?: CandidateProfileApi;
};

export const PersonalInfoBlock = ({ profile_data }: PersonalInfoBlockProps) => {
  const { t } = useTranslation();

  const bodyTypes = getBodyTypes(t);
  const employmentSectors = getEmploymentSectors(t);
  const zodiacSigns = getZodiacSigns(t);
  const ZodiacSignShape = profile_data?.zodiac_sign
    ? zodiacIcons[profile_data.zodiac_sign]
    : null;

  const tags: { icon: JSX.Element; label: string }[] = [];

  if (
    profile_data?.employment_sector &&
    profile_data.employment_sector !==
      EmploymentSector.EMPLOYMENT_SECTOR_UNSPECIFIED
  ) {
    tags.push({
      icon: <BriefcaseShape width={18} height={18} fillColor="#FFF" />,
      label: employmentSectors[profile_data.employment_sector]
    });
  }

  if (profile_data?.height_cm && profile_data.height_cm !== 0) {
    tags.push({
      icon: <RulerShape width={18} height={18} fillColor="#FFF" />,
      label: `${profile_data.height_cm} ${t('height_cm')}`
    });
  }

  if (
    profile_data?.body_type &&
    profile_data.body_type !== BodyType.BODY_TYPE_UNSPECIFIED
  ) {
    tags.push({
      icon: <BodyShape width={18} height={18} fillColor="#FFF" />,
      label: bodyTypes[profile_data.body_type]
    });
  }

  if (
    profile_data?.zodiac_sign &&
    profile_data.zodiac_sign !== ZodiacSign.ZODIAC_SIGN_UNSPECIFIED &&
    ZodiacSignShape
  ) {
    tags.push({
      icon: <ZodiacSignShape width={18} height={18} fillColor="#FFF" />,
      label: zodiacSigns[profile_data.zodiac_sign]
    });
  }

  if (tags.length === 0) return null;

  return (
    <InputContent
      title={t('personal_section')}
      style={{ marginTop: 10, marginBottom: 10 }}
    >
      <div
        style={{
          display: 'flex',
          flexWrap: 'wrap',
          gap: '8px'
        }}
      >
        {tags.map((tag, index) => (
          <div key={index} style={tagStyle}>
            {tag.icon}
            {tag.label}
          </div>
        ))}
      </div>
    </InputContent>
  );
};
